import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useFeatureEnabled } from "../context/FeatureContext";

const FeatureGate = ({ feature, children }) => {
  const enabled = useFeatureEnabled(feature);
  if (enabled) return children;
  return (
    <div className="max-w-2xl mx-auto bg-white border border-[#7AB2B2] rounded-2xl p-10 text-center space-y-4" data-testid={`feature-disabled-${feature}`}>
      <div className="w-16 h-16 mx-auto rounded-2xl bg-[#EBF4F6] text-[#09637E] flex items-center justify-center"><Lock size={30} /></div>
      <h2 className="text-lg md:text-xl font-extrabold text-[#333333]">هذه الميزة غير متاحة حالياً لحسابك</h2>
      <p className="text-sm text-[#666666]">للاستفسار يمكنك التواصل مع إدارة إمداد.</p>
      <div className="flex flex-wrap justify-center gap-2">
        <Link to="/contact-admin" className="h-11 px-5 rounded-lg bg-[#09637E] hover:bg-[#088395] text-white font-bold flex items-center" data-testid="feature-disabled-contact">تواصل مع الإدارة</Link>
        <Link to="/dashboard" className="h-11 px-5 rounded-lg border-2 border-[#09637E] text-[#09637E] font-bold flex items-center hover:bg-[#EBF4F6]" data-testid="feature-disabled-home">لوحة التحكم</Link>
      </div>
    </div>
  );
};

export default FeatureGate;
